export const TECHNICIAN_FORM_DRAFT_KEY = "technician_form_draft";

/**
 * Stable localStorage key per logged-in technician (shared-tablet safe).
 * Uses encodeURIComponent so usernames with spaces / unicode are safe as key suffixes.
 */
export function getDraftKey(username) {
  const safe = String(username || "").trim();
  if (!safe) return null;
  return `${TECHNICIAN_FORM_DRAFT_KEY}_${encodeURIComponent(safe)}`;
}

export function clearTechnicianFormDraft(username) {
  const key = getDraftKey(username);
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * True if persisted draft JSON has any field filled (aligned with TechnicianForm "isBlank" logic).
 */
export function hasMeaningfulTechnicianDraft(username) {
  const key = getDraftKey(username);
  if (!key) return false;
  try {
    const raw = localStorage.getItem(key);
    if (!raw || !String(raw).trim()) return false;
    const d = JSON.parse(raw);
    if (!d || typeof d !== "object") return false;
    const isBlank =
      !(String(d.sr || "").trim()) &&
      !(String(d.address || "").trim()) &&
      !d.appointmentType &&
      !d.routerOption &&
      !d.ontOption &&
      !d.spiralOption &&
      !d.inesLength &&
      !d.prizakia &&
      !(String(d.notes || "").trim()) &&
      !(String(d.routerSerial || "").trim()) &&
      !(String(d.ontSerial || "").trim()) &&
      !(String(d.spiralMeters || "").trim());
    return !isBlank;
  } catch {
    return false;
  }
}
